import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Redirect } from 'react-router';
import $ from 'jquery';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import createBrowserHistory from 'history/createBrowserHistory';

// Components
import Home 	from './components/home/home';
import Header 	from './components/header/header';
import Temas 	from './components/temas';
import Pages 	from './components/pages/estaticas';
import Footer 	from './components/footer/footer';

import './assets/css/style.css';


// History
const browserHistory = createBrowserHistory();

const Root = () => {
	return (
		<div>
			<Router basename={'/iniciativa/mundon'} history={browserHistory}>
				<div>
					<Header />
					<Route exact path={`${process.env.PUBLIC_URL}/`} component={Home}/>	
					<Route exact path={`${process.env.PUBLIC_URL}/temas/:pathParam`} component={Temas}/>
					<Route path={`${process.env.PUBLIC_URL}/:id`} component={Pages}/>
				</div>
			</Router>
		</div>
	)
}

ReactDOM.render(<Root history={browserHistory} />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js